import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import PropTypes from "prop-types";
import { Loader } from "arv-reactcomponents";
import FavoriteProducts from "./FavoriteProducts";
import FavoritesEmptyState from "./FavoritesEmptyState";

@inject("WishListStore")
@observer
class Favorites extends Component {
  constructor(props) {
    super(props);
    this.state = {
      favoritePageLoading: true,
    };
  }

  componentDidMount() {
    this.props.WishListStore.getWishList().then(
      res => {
        this.setState({ favoritePageLoading: false });
      },
      err => {
        this.setState({ favoritePageLoading: false });
      },
    );
  }

  render() {
    const { favoritesData } = this.props.WishListStore;
    const { favoritePageLoading } = this.state;
    if (favoritePageLoading) {
      return (
        <div className="nw-checkoutpage-initialloader nw-favoritepage-loader nwc-translucentbackground-white">
          <Loader />
        </div>
      );
    }
    const componentToRender = favoritesData.length ? (
      <FavoriteProducts.component />
    ) : (
      <FavoritesEmptyState.component />
    );
    return <div className="nw-favorites">{componentToRender}</div>;
  }
}

Favorites.wrappedComponent.propTypes = {
  WishListStore: PropTypes.shape({
    favoritesData: PropTypes.object,
    getWishList: PropTypes.func.isRequired, // eslint-disable-line
  }).isRequired,
};
const getFinalComponent = component =>
  inject("WishListStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: Favorites.wrappedComponent,
  component: Favorites,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/Favorites/index.js